import React, { useEffect, useState } from 'react';
import { Checkbox, useFirstRender } from '@insurancemenu/imenu-components-lib';
import { useRootStore } from 'store/rootStore';

interface ProductCellProps {
  productName: string;
  productId: string;
  eeClass: string;
  isInEligibleClasses: boolean;
}

const ProductCell = ({ productName, productId, eeClass, isInEligibleClasses }: ProductCellProps): JSX.Element => {
  const [isProductSelected, setIsProductSelected] = useState(isInEligibleClasses);
  const firstRender = useFirstRender();

  const {
    eeClassesStore: { updateSelectedPlanInClass },
  } = useRootStore();

  const onPlanChanged = (): void => {
    setIsProductSelected(!isProductSelected);
  };

  useEffect(() => {
    if (!firstRender) {
      updateSelectedPlanInClass(productId, isProductSelected, eeClass);
    }
  }, [isProductSelected]);

  useEffect(() => {
    setIsProductSelected(isInEligibleClasses);
  }, [isInEligibleClasses]);

  return <Checkbox label={productName} checked={isProductSelected} onChange={onPlanChanged} />;
};

export default ProductCell;
